// @flow
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import './AuthTemplate.scss';
import BackgroundColor from "../../common/BackgroundColor";

type Props = {
  form: Node,
  type: string,
};

class AuthTemplate extends Component<Props> {
  render() {
    const { form, type } = this.props;
    return (
      <div className="AuthTemplate">
        <Helmet>
          <title>{`${type} | 캐시바이`}</title>
        </Helmet>
        <BackgroundColor color="#fbfbfb" />
        <div className="main">
          <div className="wrapper">
            <div className="auth-form">{form}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default AuthTemplate;



// WEBPACK FOOTER //
// ./src/components/auth/AuthTemplate/AuthTemplate.js